import React from "react";
import { Table } from "antd";

function SummaryTable({
  columns,
  data = [],
  loading = false,
  pagination = false,
  onChange,
  rowKey = "id",
  summary,
  bordered = false,
  scroll,
  components,
  rowClassName,
  size,
}) {
  return (
    <div className="summary-table-wrapper">
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={pagination}
        onChange={onChange}
        rowKey={rowKey}
        summary={summary}
        bordered={bordered}
        scroll={scroll}
        components={components}
        rowClassName={rowClassName}
        size={size}
      />
    </div>
  );
}

export default SummaryTable;
